import Filter from "../../components/Filter";
import LineGraph from "../../components/ForecastSummary/lineGraph";
import ForecastAlertTable from "../../components/ForecastTable/forecastAlertTable";
import { useState, useEffect } from "react";
import downarrow from "../../assets/downarrowFilter.svg";
import uparrow from "../../assets/uparrowFilter.svg";
import HOF_graph1 from "../../assets/HOF_graph1.png";
import HOF_graph2 from "../../assets/HOF_graph2.png";
 
const ForecastAlert = () => {
    const [isToggleOn, setToggleOn] = useState<boolean>(true);
    const [tableHeight, setTableHeight] = useState<number>(25);
    const [isVisible, setIsVisible] = useState<boolean>(true);
    const graphTitle = [{
        flag: 1,
        title: "Demand vs Forecast",
        image : HOF_graph1
    },
    {
        flag: 2,
        title: "Stock Out Days",
        image: HOF_graph2
    }]
    const handleToggle=()=>{
        setToggleOn(!isToggleOn);
    }
    const filterShowHandler = () => {
        setIsVisible(!isVisible);
    }
    
    useEffect(() => {
        if(isVisible && isToggleOn)
            setTableHeight(26)
        else if(isVisible && !isToggleOn)
            setTableHeight(57)
        else if(!isVisible && isToggleOn)
            setTableHeight(33)
        else
            setTableHeight(66)
    },[isToggleOn,isVisible])

    return (
        <>
            <div className="relative">
                <Filter filterShowHandler={filterShowHandler} isVisible={isVisible}/>
            </div>
            {!isToggleOn && <div className="bg-[#F1F1F1] px-[2%] py-[1.2vh] grid grid-cols-2 gap-x-10">
                {graphTitle.map((each) => {
                    return <div className="flex">
                        <div className="border-[1px] border-[#BEBEBE] flex rounded
                        items-center cursor-pointer bg-[#fff]">
                            <div className="bg-[#bebebe] rounded-l">
                                <img className="rounded-l w-[8.5vw] h-full" src={each.image} alt={each.title} />
                            </div>
                            <p className="text-fs16 font-semibold p-2 py-[0]">{each.title}</p>
                        </div>
                    </div>
                })}
            </div>}
            {isToggleOn && <div className="bg-[#F1F1F1] h-[40vh] flex px-4 py-3">
                <div className="flex items-center justify-center gap-4 w-[100%]">
                    <LineGraph flag={1} title={"Demand vs Forecast"} />
                    <LineGraph flag={2} title={"Stock Out Days"} />
                </div>
            </div>}
            <div className="flex flex-col gap-1 flex-grow h-[36vh] relative">
                <div className="absolute flex left-2/4 z-[10] translate-x-[-50%] translate-y-[-50%] justify-center cursor-pointer" onClick={handleToggle}>
                    {isToggleOn && <img className="w-[1.5vw]" src={uparrow} alt="upArrow" />}
                    {!isToggleOn && <img className="w-[1.5vw]" src={downarrow} alt="downArrow" />}
                </div>
                <ForecastAlertTable tableHeight={tableHeight}/>
            </div>
        </>
    );
}
 
export default ForecastAlert;
